"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Thames21GreenWallModule_exports = {};
__export(Thames21GreenWallModule_exports, {
  Thames21GreenWallModule: () => Thames21GreenWallModule
});
module.exports = __toCommonJS(Thames21GreenWallModule_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_types = require("@cartographerio/types");
var import_core = require("../../core/index.js");
const Thames21GreenWallModule = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("thames21GreenWallModule"),
  title: "Green Wall Module",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("thames21GreenWallModule"),
      title: "Green Wall Module",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("thames21GreenWallModule"),
        attribution: []
      }),
      defaultAttribute: "status",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "General",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "status",
              label: "Status",
              enum: import_types.SurveyStatusEnum
            }),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/time",
              buckets: "auto"
            }),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey")
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Thames21GreenWallModule
});
//# sourceMappingURL=Thames21GreenWallModule.js.map
